import { FC } from 'react';

import { useInitTracker } from '../../../feature-player/hooks/tracker/use-init-tracker';
import { usePlayerAnalytics } from '../../../feature-player/hooks/tracker/use-player-analytics';
import { getStreamsTrackingData } from '../../../feature-player/utils/get-streams-tracking-data';
import { useCurrentSportStream } from '../../hooks/useCurrentSportStream';

interface SportPlayerTrackerProps {
    contentId: string;
    psid: string;
}

export const SportPlayerTracker: FC<SportPlayerTrackerProps> = ({ contentId, psid }) => {
    const streamTrackingData = useCurrentSportStream(contentId)?.streamMeta?.trackings;

    useInitTracker({
        contentId,
        streamTrackingData: getStreamsTrackingData(streamTrackingData),
        additionalData: { isLive: 1 },
    });
    usePlayerAnalytics({
        contentId,
        psid,
        manifestUrl: useCurrentSportStream(contentId)?.uri,
    });

    return null;
};
